// Compiled at 2026-10-07T06:21:14.844Z
export const $Roles = { "Admin": "System.Admin" } as const;
